import { Suspense, type ReactNode } from "react";
import { LoadingSkeleton } from "@a2z/ui";
import { keys } from "@/lib/i18n/portal";
import { useTranslations } from "@/lib/i18n/intl";

/** Page code loads inside the existing guarded route and shell. */
export function RouteSuspense({ children }: { children: ReactNode }) {
  const t = useTranslations();
  return <Suspense fallback={<div role="status"><span className="sr-only">{t(keys.common.loading)}</span><LoadingSkeleton /></div>}>{children}</Suspense>;
}
